import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendContinuousOptimizationVariant,
  BackendMutationUpdateContinuousOptimizationVariantStatusArgs,
} from 'src/types/backend';

import { FRAGMENT_CO_VARIANT } from './schema';

const MUTATION = gql`
  mutation updateCOVariant($id: ID!, $status: String!) {
    updateContinuousOptimizationVariantStatus(id: $id, status: $status) {
      ...ContinuousOptimizationVariant
    }
  }
  ${FRAGMENT_CO_VARIANT}
`;

type Variables = BackendMutationUpdateContinuousOptimizationVariantStatusArgs;
type Result = BackendContinuousOptimizationVariant;

export const updateCOVariantStatus = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
